module.exports = __webpack_public_path__ + "images/feature/feature_1220_2-fec3427699973e0e5ff350893d66e42a.png";